import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AuthGuard } from './core/guards/auth-guard';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { LoggedInAuthGuard } from './core/guards/auth-in-guard';
import { InitialDataResolver } from './core/resolvers/initial-data.resolver';
import { PlanPagesComponent } from './plan-pages/plan-pages.component';
import { TodoResolver } from './core/resolvers/todo.resolver';
import { MaintenancePageComponent } from './maintenance-page/maintenance-page.component';
import { MaintenanceGuard } from './core/guards/maintenance.guard';
import { NotMaintenanceGuard } from './core/guards/not-maintenance.guard';
import { EPaymentPlanComponent } from './e-payment-plan/e-payment-plan.component';
import { SessionTimeoutPageComponent } from './session-timeout-page/session-timeout-page.component';
import { InActivePageComponent } from './in-active-page/in-active-page.component';
import { NotInActiveGuard } from './core/guards/not-in-active.guard';
import { InActiveGuard } from './core/guards/in-active.guard';
import { VerifiedPageComponent } from './auth-pages/verified-page/verified-page.component';
import { ServerErrorPageComponent } from './server-error-page/server-error-page.component';
import { ServerErrorGuard } from './core/guards/server-error.guard';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  // Server error page - NO guards, always accessible
  {
    path: 'server-error',
    component: ServerErrorPageComponent
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [ServerErrorGuard, AuthGuard, MaintenanceGuard, InActiveGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./layouts/admin-layout/admin-layout.module').then(m => m.AdminLayoutModule),
        resolve: { initialData: InitialDataResolver, configStatus: TodoResolver },
      }
    ]
  },
  {
    path: '',
    component: AuthLayoutComponent,
    canActivate: [ServerErrorGuard], // Block auth pages when server is down
    children: [
      {
        path: '',
        canActivate: [LoggedInAuthGuard],
        loadChildren: () => import('./layouts/auth-layout/auth-layout.module').then(m => m.AuthLayoutModule)
      }
    ]
  },
  {
    path: '',
    component: PlanPagesComponent,
    canActivate: [ServerErrorGuard, AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./plan-pages/plan-pages.module').then(m => m.PlanPagesModule),
      }
    ]
  },
  {
    path: '',
    component: PlanPagesComponent,
    canActivate: [ServerErrorGuard, AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./bill-pages/bill-pages.module').then(m => m.BillPagesModule),
      }
    ]
  },
  {
    path: '',
    component: MaintenancePageComponent,
    canActivate: [ServerErrorGuard, AuthGuard, NotMaintenanceGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./maintenance-page/maintenance-page.module').then(m => m.MaintenancePageModule),
      }
    ]
  },
  {
    path: '',
    component: InActivePageComponent,
    canActivate: [ServerErrorGuard, AuthGuard, NotInActiveGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./in-active-page/in-active-page.module').then(m => m.InActivePageModule),
      }
    ]
  },
  {
    path: '',
    component: EPaymentPlanComponent,
    canActivate: [ServerErrorGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./e-payment-plan/e-payment-plan.module').then(m => m.EPaymentPlanModule),
      }
    ]
  },
  {
    path: '',
    component: SessionTimeoutPageComponent,
    canActivate: [ServerErrorGuard, AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./session-timeout-page/session-timeout-page.module').then(m => m.SessionTimeoutPageModule),
      }
    ]
  },
  {
    path: 'verification/:ID/:UUID',
    component: VerifiedPageComponent,
    canActivate: [ServerErrorGuard]
  },
  {
    path: '**',
    redirectTo: 'login'
  }
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes, {
      useHash: true
    })
  ],
  exports: [
  ],
})
export class AppRoutingModule { }